"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hasWindow() {
    return typeof window === "object";
}
exports.default = hasWindow;
//# sourceMappingURL=hasWindow.js.map